<template>
  <section class='price-component'>
    <div class='title'>{{title}}</div>
    <div class='content'>
      <ul class='price-list'>
        <li v-for='(item, index) in data' :key='index'>
          <span>{{item.name}}</span>
          <span class='flex-grow'></span>
          <span class='value'>{{item.value}}{{item.unit}}</span>
        </li>
      </ul>
      <p class='text2' v-if="moreTip">请联系 <span>400-646-1860</span> 获取详细报价</p>
      <button class='button' @click='redirectConsole'>免费体验</button>
    </div>
  </section>
</template>

<script>
import { CONSOLE_SITE_URL } from '../utils/constants';
export default {
  metaInfo: {
    title: '实时音视频PaaS服务-0启动成本-马兰头医学科技',
    meta: [
      {
        name: 'keywords',
        content: 'webrtc,公有云,私有云,实时音视频,小程序,实时通信,免费视频通话,互动白板,互动直播'
      },
      {
        name: 'description',
        content: '马兰头医学科技新一代实时音视频通信平台，4行代码即可快速搭建应用。高度组件化、高度模块化。10年+技术探索与积淀，研发独有的编解码核心技术，成就业内领先极低时延的音视频专家'
      },
    ]
  },
  name: 'PriceConponent',
  props: ['title', 'data', 'moreTip'],
  methods: {
    redirectConsole() {
      window.open(CONSOLE_SITE_URL);
    },
  },
}
</script>

<style lang="less" scoped>
.price-component {
  width: 1000px;
  zoom: 0.56;
  background: #ffffff;
  box-shadow: 0px 2px 16px 3px rgba(59,113,241,0.11);
  .text2 {
    font-size: 38px;
    font-weight: 400;
    color: #3b71f1;
    line-height: 33px;
    margin-top: 10px;
    text-align: center;
    height: 307px;
    padding-top: 150px;
    span {
      color: #f00;
    }
  }
  .title {
    height: 80px;
    line-height: 80px;
    background: linear-gradient(325deg,#3b71f2 7%, #8da8ff 95%);
    border-radius: 10px 10px 0 0;
    text-align: left;
    color: #fff;
    font-weight:600;
    font-size: 38px;
    padding-left: 55px;
  }
  .content {
    padding: 40px 79px 60px;
    .price-list {
      li {
        display: flex;
        align-items: center;
        font-size: 25px;
        font-weight: 400;
        color: #333333;
        &:not(:last-child) {
          margin-bottom: 55px;
        }
        .flex-grow {
          flex: 1;
          border-bottom: 2px dashed #333;
          margin: 0 16px;
        }
        .value {
          width: 165px;
        }
      }
    }
    .button {
      width: 232px;
      height: 71px;
      opacity: 1;
      border: 2px solid #3b71f1;
      border-radius: 7px;
      display: block;
      margin-top: 36px;
      margin-bottom: 55px;
      line-height: 40px;
      background: #ffffff;
      float: right;

      text-align: center;
      outline: none;
      font-size: 32px;
      font-weight: 400;
      color: #3b72f2;
      cursor: pointer;
      &:hover {
        opacity: 0.9;
      }
    }
  }
}
</style>